import {
  Grid,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import TableCard from 'lib/designSystem/Card/TableCard';
import React from 'react';

const BankReconciliationLoadingState: React.FC = () => (
  <>
    <Grid container spacing={2} sx={{ mb: 2 }}>
      {[0, 1].map((card) => (
        <Grid item xs={12} md={6} key={`summary-skeleton-${card}`}>
          <TableCard sx={{ p: 2 }} enabledEffects={false}>
            <Skeleton variant="text" width="35%" height={34} />
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <Skeleton variant="text" width="55%" height={20} />
                <Skeleton variant="text" width="70%" height={36} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Skeleton variant="text" width="65%" height={20} />
                <Skeleton variant="text" width="70%" height={36} />
              </Grid>
            </Grid>
          </TableCard>
        </Grid>
      ))}
    </Grid>
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {Array.from({ length: 8 }).map((_, index) => (
              <TableCell key={`table-head-skeleton-${index}`}>
                <Skeleton variant="text" width="80%" />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: 5 }).map((_, rowIndex) => (
            <TableRow key={`table-row-skeleton-${rowIndex}`}>
              {Array.from({ length: 8 }).map((__, colIndex) => (
                <TableCell key={`table-cell-skeleton-${rowIndex}-${colIndex}`}>
                  <Skeleton variant="text" width="90%" />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
);

export default BankReconciliationLoadingState;
